(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-diagnostic-quiz"] && !Shopify.designMode) return;
  try {
    
  class SsDiagnosticQuiz extends HTMLElement {
    constructor() {
      super();
      this.answers = {};
      this.step = 0;
      this.initialized = false;
      this.CHECK_SVG =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const labelsEl = this.querySelector('script[data-ssd-labels]');
      this.labels = labelsEl ? JSON.parse(labelsEl.textContent) : {};
      this.questions = this.parseQuestions();
      this.total = this.questions.length;
      this.stage = this.querySelector('[data-ssd-stage]');
      this.intro = this.querySelector('[data-ssd-intro]');
      this.progress = this.querySelector('[data-ssd-progress]');
      this.progressBar = this.querySelector('[data-ssd-progress-bar]');
      this.progressMeta = this.querySelector('[data-ssd-progress-meta]');
      this.w3fKey = this.dataset.w3fKey || '';
      this.subjectPrefixEmail = this.dataset.subjectPrefixEmail || '[Sélection]';
      this.subjectPrefixRdv = this.dataset.subjectPrefixRdv || '[RDV]';
      this.fromName = this.dataset.fromName || 'Consultation Skincare';
      this.privacyUrl = this.dataset.privacyUrl || '/policies/privacy-policy';
      const startBtn = this.querySelector('[data-ssd-start]');
      if (startBtn) {
        startBtn.addEventListener('click', () => {
          this.step = 1;
          this.render();
        });
      }
    }

    parseQuestions() {
      return Array.from(this.querySelectorAll('script[data-ssd-question]'))
        .map((el) => {
          let raw;
          try {
            raw = JSON.parse(el.textContent);
          } catch (e) {
            return null;
          }
          const q = {
            id: raw.id,
            type: raw.type,
            part: raw.part || '',
            title: raw.title || '',
            rule: raw.rule || '',
            required: raw.required === true || raw.required === 'true',
            max: parseInt(raw.max, 10) || 0,
            placeholder: raw.placeholder || '',
          };
          if (q.type === 'single' || q.type === 'multi') {
            q.options = (raw.options || '')
              .split('\n')
              .map((s) => s.trim())
              .filter(Boolean);
          } else if (q.type === 'matrix') {
            q.items = (raw.matrixItems || '')
              .split('\n')
              .map((s) => s.trim())
              .filter(Boolean);
            q.choices = (raw.matrixChoices || '')
              .split('|')
              .map((s) => s.trim())
              .filter(Boolean);
            q.freeLabel = raw.matrixFreeLabel || '';
            q.freePlaceholder = raw.matrixFreePlaceholder || '';
          }
          return q;
        })
        .filter(Boolean);
    }

    render() {
      this.intro.removeAttribute('data-active');
      this.stage.innerHTML = '';

      if (this.step >= 1 && this.step <= this.total) {
        this.renderQuestion(this.questions[this.step - 1]);
        this.updateProgress(this.step, this.total);
      } else if (this.step === this.total + 1) {
        this.renderPath();
        this.updateProgress(this.total, this.total, this.labels.pathProgressLabel);
      } else if (this.step === this.total + 2) {
        this.renderContact();
        this.updateProgress(this.total, this.total, this.labels.contactProgressLabel);
      } else if (this.step === this.total + 3) {
        this.renderSuccess();
        this.progress.removeAttribute('data-visible');
        this.progressMeta.textContent = '';
      }
      this.scrollToTop();
    }

    updateProgress(cur, tot, override) {
      this.progress.setAttribute('data-visible', 'true');
      const pct = Math.min(100, Math.round((cur / tot) * 100));
      this.progressBar.style.width = pct + '%';
      const tmpl = this.labels.questionLabel || 'Question %1 / %2';
      const label = override || tmpl.replace('%1', cur).replace('%2', tot);
      this.progressMeta.innerHTML = '<span>' + this.escapeHtml(label) + '</span><span></span>';
    }

    renderQuestion(q) {
      const s = document.createElement('div');
      s.className = 'ss-diagnostic-quiz__screen';
      s.setAttribute('data-active', 'true');
      let html = '';
      if (q.part) html += '<div class="ss-diagnostic-quiz__eyebrow">' + this.escapeHtml(q.part) + '</div>';
      html += '<h1 class="ss-diagnostic-quiz__title">' + this.escapeHtml(q.title) + '</h1>';
      if (q.rule) html += '<div class="ss-diagnostic-quiz__rule" data-rule>' + this.escapeHtml(q.rule) + '</div>';

      if (q.type === 'text') {
        const val = this.answers[q.id] || '';
        html +=
          '<textarea class="ss-diagnostic-quiz__textarea" data-free placeholder="' +
          this.escapeAttr(q.placeholder) +
          '">' +
          this.escapeHtml(val) +
          '</textarea>';
      } else if (q.type === 'matrix') {
        html += '<div class="ss-diagnostic-quiz__matrix" data-mtx></div>';
        html +=
          '<div class="ss-diagnostic-quiz__mfree"><label class="ss-diagnostic-quiz__lbl">' +
          this.escapeHtml(q.freeLabel) +
          '</label><textarea class="ss-diagnostic-quiz__textarea" data-mtx-free style="min-height:70px" placeholder="' +
          this.escapeAttr(q.freePlaceholder) +
          '"></textarea></div>';
      } else {
        html += '<div class="ss-diagnostic-quiz__options" data-opts></div>';
      }
      html += this.navHtml(this.step > 1, this.labels.continueLabel || 'Continuer');
      s.innerHTML = html;
      this.stage.appendChild(s);

      if (q.type === 'single' || q.type === 'multi') {
        const cont = s.querySelector('[data-opts]');
        const isMulti = q.type === 'multi';
        if (isMulti && !Array.isArray(this.answers[q.id])) {
          this.answers[q.id] = this.answers[q.id] ? [this.answers[q.id]] : [];
        }
        q.options.forEach((opt, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ss-diagnostic-quiz__opt';
          if (isMulti) b.setAttribute('data-multi', '');
          b.style.animationDelay = i * 0.035 + 's';
          const chosen = isMulti ? this.answers[q.id].includes(opt) : this.answers[q.id] === opt;
          if (chosen) b.setAttribute('data-selected', '');
          b.innerHTML =
            '<span class="ss-diagnostic-quiz__opt-mark">' +
            this.CHECK_SVG +
            '</span><span>' +
            this.escapeHtml(opt) +
            '</span>';
          b.addEventListener('click', () => {
            if (isMulti) {
              const arr = this.answers[q.id];
              const idx = arr.indexOf(opt);
              if (idx > -1) {
                arr.splice(idx, 1);
                b.removeAttribute('data-selected');
              } else {
                if (q.max && arr.length >= q.max) {
                  this.flashRule(s);
                  return;
                }
                arr.push(opt);
                b.setAttribute('data-selected', '');
              }
            } else {
              this.answers[q.id] = opt;
              s.querySelectorAll('.ss-diagnostic-quiz__opt').forEach((o) => o.removeAttribute('data-selected'));
              b.setAttribute('data-selected', '');
            }
          });
          cont.appendChild(b);
        });
      } else if (q.type === 'matrix') {
        if (
          !this.answers[q.id] ||
          typeof this.answers[q.id] !== 'object' ||
          !this.answers[q.id].items
        ) {
          this.answers[q.id] = { items: {}, libre: '' };
        }
        const store = this.answers[q.id];
        const mtx = s.querySelector('[data-mtx]');
        q.items.forEach((name) => {
          const row = document.createElement('div');
          row.className = 'ss-diagnostic-quiz__mrow';
          const lab = document.createElement('div');
          lab.className = 'ss-diagnostic-quiz__mlabel';
          lab.textContent = name;
          const chips = document.createElement('div');
          chips.className = 'ss-diagnostic-quiz__mchips';
          q.choices.forEach((ch) => {
            const c = document.createElement('button');
            c.type = 'button';
            c.className = 'ss-diagnostic-quiz__mchip';
            c.textContent = ch;
            if (store.items[name] === ch) c.setAttribute('data-selected', '');
            c.addEventListener('click', () => {
              chips
                .querySelectorAll('.ss-diagnostic-quiz__mchip')
                .forEach((x) => x.removeAttribute('data-selected'));
              c.setAttribute('data-selected', '');
              store.items[name] = ch;
            });
            chips.appendChild(c);
          });
          row.appendChild(lab);
          row.appendChild(chips);
          mtx.appendChild(row);
        });
        const free = s.querySelector('[data-mtx-free]');
        if (free) {
          free.value = store.libre || '';
          free.addEventListener('input', () => {
            store.libre = free.value;
          });
        }
      }
      this.wireNav(s, q);
    }

    flashRule(scope) {
      const m = scope.querySelector('[data-rule]');
      if (!m) return;
      m.setAttribute('data-flash', 'true');
      setTimeout(() => m.removeAttribute('data-flash'), 900);
    }

    flashTitle(scope) {
      const t = scope.querySelector('.ss-diagnostic-quiz__title');
      if (t) {
        t.style.color = 'var(--color-error)';
        setTimeout(() => {
          t.style.color = '';
        }, 800);
      }
    }

    renderContact() {
      const s = document.createElement('div');
      s.className = 'ss-diagnostic-quiz__screen';
      s.setAttribute('data-active', 'true');
      const consentHtml = (this.labels.consentText || '')
        .replace(
          '%link_start%',
          '<a href="' + this.escapeAttr(this.privacyUrl) + '" target="_blank" rel="noopener">'
        )
        .replace('%link_end%', '</a>');
      s.innerHTML =
        '<div class="ss-diagnostic-quiz__eyebrow">' +
        this.escapeHtml(this.labels.contactEyebrow || '') +
        '</div>' +
        '<h1 class="ss-diagnostic-quiz__title">' +
        this.escapeHtml(this.labels.contactTitle || '') +
        '</h1>' +
        '<div class="ss-diagnostic-quiz__hint">' +
        this.escapeHtml(this.labels.contactHint || '') +
        '</div>' +
        '<div class="ss-diagnostic-quiz__grid">' +
        '<div><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelFirstName) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="prenom" autocomplete="given-name"></div>' +
        '<div><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelLastName) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="nom" autocomplete="family-name"></div>' +
        '<div class="ss-diagnostic-quiz__grid-full"><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelEmail) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="email" type="email" autocomplete="email" placeholder="' +
        this.escapeAttr(this.labels.placeholderEmail) +
        '"></div>' +
        '<div class="ss-diagnostic-quiz__grid-full"><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelPhone) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="tel" type="tel" autocomplete="tel" placeholder="' +
        this.escapeAttr(this.labels.placeholderPhone) +
        '"></div>' +
        '<div class="ss-diagnostic-quiz__grid-full"><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelAddress) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="adresse" autocomplete="street-address" placeholder="' +
        this.escapeAttr(this.labels.placeholderAddress) +
        '"></div>' +
        '<div><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelPostalCode) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="cp" autocomplete="postal-code"></div>' +
        '<div><label class="ss-diagnostic-quiz__lbl">' +
        this.escapeHtml(this.labels.labelCity) +
        '</label><input class="ss-diagnostic-quiz__field" data-c="ville" autocomplete="address-level2"></div>' +
        '</div>' +
        '<label class="ss-diagnostic-quiz__consent"><input type="checkbox" data-c="consent"><span>' +
        consentHtml +
        '</span></label>' +
        '<div class="ss-diagnostic-quiz__field-err" data-contact-err>' +
        this.escapeHtml(this.labels.errContactMissing || '') +
        '</div>' +
        '<div class="ss-diagnostic-quiz__err" data-send-err></div>' +
        this.navHtml(
          true,
          this.answers._path === 'rdv'
            ? this.labels.pathSubmitRdv || ''
            : this.labels.pathSubmitEmail || ''
        );
      this.stage.appendChild(s);

      ['prenom', 'nom', 'email', 'tel', 'adresse', 'cp', 'ville'].forEach((k) => {
        const el = s.querySelector('[data-c="' + k + '"]');
        if (el && this.answers['_' + k]) el.value = this.answers['_' + k];
      });
      if (this.answers._consent) s.querySelector('[data-c="consent"]').checked = true;

      this.wireNav(s, null, () => {
        const get = (sel) => (s.querySelector(sel).value || '').trim();
        const prenom = get('[data-c="prenom"]');
        const nom = get('[data-c="nom"]');
        const email = get('[data-c="email"]');
        const tel = get('[data-c="tel"]');
        const adresse = get('[data-c="adresse"]');
        const cp = get('[data-c="cp"]');
        const ville = get('[data-c="ville"]');
        const consent = s.querySelector('[data-c="consent"]').checked;
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!prenom || !nom || !emailOk || !tel || !consent) {
          s.querySelector('[data-contact-err]').setAttribute('data-visible', 'true');
          return false;
        }
        Object.assign(this.answers, {
          _prenom: prenom,
          _nom: nom,
          _email: email,
          _tel: tel,
          _adresse: adresse,
          _cp: cp,
          _ville: ville,
          _consent: true,
        });
        this.submit(s);
        return false;
      });
    }

    renderPath() {
      const s = document.createElement('div');
      s.className = 'ss-diagnostic-quiz__screen';
      s.setAttribute('data-active', 'true');
      s.innerHTML =
        '<div class="ss-diagnostic-quiz__eyebrow">' +
        this.escapeHtml(this.labels.pathScreenEyebrow || '') +
        '</div>' +
        '<h1 class="ss-diagnostic-quiz__title">' +
        this.escapeHtml(this.labels.pathScreenTitle || '') +
        '</h1>' +
        '<div class="ss-diagnostic-quiz__paths">' +
        '<button type="button" class="ss-diagnostic-quiz__path" data-path="email">' +
        '<span class="ss-diagnostic-quiz__path-ico">✶</span>' +
        '<h3>' +
        this.escapeHtml(this.labels.pathEmailTitle || '') +
        '</h3>' +
        '<p>' +
        this.escapeHtml(this.labels.pathEmailDesc || '') +
        '</p>' +
        '</button>' +
        '<button type="button" class="ss-diagnostic-quiz__path" data-path="rdv">' +
        '<span class="ss-diagnostic-quiz__path-ico">❋</span>' +
        '<h3>' +
        this.escapeHtml(this.labels.pathRdvTitle || '') +
        '</h3>' +
        '<p>' +
        this.escapeHtml(this.labels.pathRdvDesc || '') +
        '</p>' +
        '</button>' +
        '</div>' +
        '<div data-slot-area></div>' +
        '<div class="ss-diagnostic-quiz__err" data-send-err></div>' +
        this.navHtml(true, this.labels.continueLabel || 'Continuer');
      this.stage.appendChild(s);

      const slotArea = s.querySelector('[data-slot-area]');
      const submitBtn = s.querySelector('[data-next]');
      submitBtn.disabled = true;

      s.querySelectorAll('.ss-diagnostic-quiz__path').forEach((card) => {
        card.addEventListener('click', () => {
          s.querySelectorAll('.ss-diagnostic-quiz__path').forEach((c) => c.removeAttribute('data-selected'));
          card.setAttribute('data-selected', '');
          this.answers._path = card.dataset.path;
          if (card.dataset.path === 'rdv') {
            this.renderSlots(slotArea);
            submitBtn.disabled = !(this.answers._slotDay && this.answers._slotTime);
          } else {
            slotArea.innerHTML = '';
            this.answers._slotDay = null;
            this.answers._slotTime = null;
            submitBtn.disabled = false;
          }
        });
      });

      this.wireNav(s, null, () => {
        if (!this.answers._path) {
          this.showSendErr(s, this.labels.errPathMissing || '');
          return false;
        }
        if (this.answers._path === 'rdv' && (!this.answers._slotDay || !this.answers._slotTime)) {
          this.showSendErr(s, this.labels.errSlotMissing || '');
          return false;
        }
        return true;
      });
    }

    renderSlots(area) {
      const days = this.generateDays(12);
      area.innerHTML =
        '<div><div class="ss-diagnostic-quiz__slot-title">' +
        this.escapeHtml(this.labels.slotChooseDay || '') +
        '</div>' +
        '<div class="ss-diagnostic-quiz__days" data-days-row></div>' +
        '<div data-times-area></div></div>';
      const row = area.querySelector('[data-days-row]');
      days.forEach((d) => {
        const el = document.createElement('div');
        el.className = 'ss-diagnostic-quiz__day';
        el.innerHTML =
          '<div class="ss-diagnostic-quiz__day-dow">' +
          this.escapeHtml(d.dow) +
          '</div>' +
          '<div class="ss-diagnostic-quiz__day-num">' +
          d.num +
          '</div>' +
          '<div class="ss-diagnostic-quiz__day-mon">' +
          this.escapeHtml(d.mon) +
          '</div>';
        el.addEventListener('click', () => {
          row.querySelectorAll('.ss-diagnostic-quiz__day').forEach((x) => x.removeAttribute('data-selected'));
          el.setAttribute('data-selected', '');
          this.answers._slotDay = d.full;
          this.answers._slotTime = null;
          this.renderTimes(area.querySelector('[data-times-area]'), d.isSat);
          this.refreshSubmitState();
        });
        row.appendChild(el);
      });
    }

    renderTimes(area, isSat) {
      const times = isSat
        ? ['10:00', '11:00', '12:00']
        : ['10:00', '11:00', '12:00', '14:00', '15:00', '16:00', '17:00', '18:00'];
      area.innerHTML =
        '<div class="ss-diagnostic-quiz__slot-title" style="margin-top:24px">' +
        this.escapeHtml(this.labels.slotChooseTime || '') +
        '</div>' +
        '<div class="ss-diagnostic-quiz__times" data-times-row></div>';
      const row = area.querySelector('[data-times-row]');
      times.forEach((t) => {
        const el = document.createElement('div');
        el.className = 'ss-diagnostic-quiz__time';
        el.textContent = t;
        el.addEventListener('click', () => {
          row.querySelectorAll('.ss-diagnostic-quiz__time').forEach((x) => x.removeAttribute('data-selected'));
          el.setAttribute('data-selected', '');
          this.answers._slotTime = t;
          this.refreshSubmitState();
        });
        row.appendChild(el);
      });
    }

    refreshSubmitState() {
      const btn = this.stage.querySelector('[data-next]');
      if (!btn) return;
      if (this.answers._path === 'rdv') {
        btn.disabled = !(this.answers._slotDay && this.answers._slotTime);
      }
    }

    generateDays(n) {
      const FR_DOW = this.labels.frDow || ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
      const FR_MON =
        this.labels.frMonths ||
        ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
      const out = [];
      const today = new Date();
      let i = 1;
      while (out.length < n) {
        const d = new Date(today);
        d.setDate(today.getDate() + i);
        i++;
        const dow = d.getDay();
        if (dow === 0) continue;
        out.push({
          dow: FR_DOW[dow],
          num: d.getDate(),
          mon: FR_MON[d.getMonth()],
          isSat: dow === 6,
          full: FR_DOW[dow] + ' ' + d.getDate() + ' ' + FR_MON[d.getMonth()] + ' ' + d.getFullYear(),
        });
      }
      return out;
    }

    navHtml(showBack, primaryLabel) {
      return (
        '<div class="ss-diagnostic-quiz__nav">' +
        (showBack
          ? '<button type="button" class="button-secondary" data-back>' +
            this.escapeHtml(this.labels.backLabel || '←  Retour') +
            '</button>'
          : '') +
        '<div class="ss-diagnostic-quiz__nav-spacer"></div>' +
        '<button type="button" class="button" data-next>' +
        this.escapeHtml(primaryLabel) +
        '</button>' +
        '</div>'
      );
    }

    wireNav(scope, q, customNext) {
      const back = scope.querySelector('[data-back]');
      const next = scope.querySelector('[data-next]');
      if (back) {
        back.addEventListener('click', () => {
          this.step--;
          if (this.step < 1) {
            this.goIntro();
            return;
          }
          this.render();
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          if (q && q.type === 'text') {
            this.answers[q.id] = (scope.querySelector('[data-free]').value || '').trim();
          }
          if (q && q.type === 'single' && q.required && !this.answers[q.id]) {
            this.flashTitle(scope);
            return;
          }
          if (
            q &&
            q.type === 'multi' &&
            q.required &&
            (!this.answers[q.id] || this.answers[q.id].length === 0)
          ) {
            this.flashTitle(scope);
            return;
          }
          if (customNext) {
            if (customNext() === false) return;
          }
          this.step++;
          this.render();
        });
      }
    }

    goIntro() {
      this.step = 0;
      this.stage.innerHTML = '';
      this.intro.setAttribute('data-active', 'true');
      this.progress.removeAttribute('data-visible');
      this.progressMeta.textContent = '';
      this.scrollToTop();
    }

    fmtAnswer(q) {
      const a = this.answers[q.id];
      if (q.type === 'matrix') {
        const it = (a && a.items) || {};
        const parts = q.items.map((n) => n + ' = ' + (it[n] || '—'));
        let str = parts.join(' · ');
        const libre = ((a && a.libre) || '').trim();
        if (libre) str += ' · Autres actifs préférés : ' + libre;
        return str;
      }
      if (Array.isArray(a)) return a.length ? a.join(' · ') : '—';
      return a || '—';
    }

    buildPayload() {
      const lines = [];
      lines.push('════════════════════════════════════');
      lines.push('NOUVELLE CONSULTATION SKINCARE');
      lines.push('════════════════════════════════════');
      lines.push('');
      lines.push('» CONTACT');
      lines.push('Prénom : ' + this.answers._prenom);
      lines.push('Nom : ' + this.answers._nom);
      lines.push('Email : ' + this.answers._email);
      lines.push('Téléphone : ' + this.answers._tel);
      lines.push(
        'Adresse : ' +
          [this.answers._adresse, (this.answers._cp || '') + ' ' + (this.answers._ville || '')]
            .filter((x) => x && x.trim())
            .join(', ')
      );
      lines.push('');
      lines.push('» DEMANDE');
      if (this.answers._path === 'rdv') {
        lines.push('→ RENDEZ-VOUS DIAGNOSTIC (appel téléphonique)');
        lines.push('Créneau souhaité : ' + this.answers._slotDay + ' à ' + this.answers._slotTime);
      } else {
        lines.push('→ SÉLECTION DE PRODUITS PAR EMAIL');
      }
      lines.push('');
      lines.push('» RÉPONSES AU QUESTIONNAIRE');
      this.questions.forEach((q, idx) => {
        lines.push('');
        lines.push(idx + 1 + '. ' + q.title);
        if (q.type === 'matrix') {
          const it = (this.answers[q.id] && this.answers[q.id].items) || {};
          q.items.forEach((name) => lines.push('   - ' + name + ' : ' + (it[name] || '—')));
          const libre = ((this.answers[q.id] && this.answers[q.id].libre) || '').trim();
          lines.push('   Autres actifs préférés : ' + (libre || '—'));
        } else {
          lines.push('   ' + this.fmtAnswer(q));
        }
      });
      lines.push('');
      lines.push('════════════════════════════════════');

      const prefix = this.answers._path === 'rdv' ? this.subjectPrefixRdv : this.subjectPrefixEmail;
      const subject = prefix + ' Consultation — ' + this.answers._prenom + ' ' + this.answers._nom;

      const payload = {
        access_key: this.w3fKey,
        subject: subject,
        from_name: this.fromName,
        replyto: this.answers._email,
        'Type de demande':
          this.answers._path === 'rdv' ? 'Rendez-vous diagnostic' : 'Sélection produits par email',
        'Créneau RDV':
          this.answers._path === 'rdv' ? this.answers._slotDay + ' à ' + this.answers._slotTime : '—',
        'Prénom': this.answers._prenom,
        'Nom': this.answers._nom,
        'Email client': this.answers._email,
        'Téléphone': this.answers._tel,
        'Adresse': [
          this.answers._adresse,
          (this.answers._cp || '') + ' ' + (this.answers._ville || ''),
        ]
          .filter((x) => x && x.trim())
          .join(', '),
        message: lines.join('\n'),
        botcheck: '',
      };
      this.questions.forEach((q, idx) => {
        payload['Q' + (idx + 1)] = this.fmtAnswer(q);
      });
      return payload;
    }

    async submit(scope) {
      const err = scope.querySelector('[data-send-err]');
      if (err) err.removeAttribute('data-visible');

      if (!this.w3fKey) {
        this.showSendErr(scope, this.labels.errSubmit || 'Configuration manquante.');
        return;
      }

      this.stage.innerHTML =
        '<div class="ss-diagnostic-quiz__screen ss-diagnostic-quiz__center" data-active="true">' +
        '<div class="ss-diagnostic-quiz__spinner"></div>' +
        '<h2>' +
        this.escapeHtml(this.labels.sendingTitle || '') +
        '</h2>' +
        '<p>' +
        this.escapeHtml(this.labels.sendingBody || '') +
        '</p></div>';
      this.progress.removeAttribute('data-visible');
      this.progressMeta.textContent = '';

      try {
        const res = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(this.buildPayload()),
        });
        const data = await res.json();
        if (data.success) {
          this.step = this.total + 3;
          this.render();
        } else {
          throw new Error(data.message || 'Échec');
        }
      } catch (e) {
        this.step = this.total + 2;
        this.render();
        this.showSendErr(this.stage, (this.labels.errSubmit || '') + ' (' + e.message + ')');
      }
    }

    showSendErr(scope, msg) {
      let err = scope.querySelector('[data-send-err]');
      if (!err) err = this.stage.querySelector('[data-send-err]');
      if (err) {
        err.textContent = msg;
        err.setAttribute('data-visible', 'true');
      }
    }

    renderSuccess() {
      const rdv = this.answers._path === 'rdv';
      const s = document.createElement('div');
      s.className = 'ss-diagnostic-quiz__screen ss-diagnostic-quiz__center';
      s.setAttribute('data-active', 'true');
      const title = rdv
        ? this.labels.successRdvTitle || ''
        : (this.labels.successEmailTitle || '').replace('%name%', this.answers._prenom);
      const body = rdv ? this.labels.successRdvBody || '' : this.labels.successEmailBody || '';
      s.innerHTML =
        '<div class="ss-diagnostic-quiz__seal"><svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"><polyline points="20 6 9 17 4 12"/></svg></div>' +
        '<h2>' +
        this.escapeHtml(title) +
        '</h2>' +
        '<p>' +
        this.escapeHtml(body) +
        '</p>' +
        (rdv
          ? '<div class="ss-diagnostic-quiz__recap">' +
            this.escapeHtml(this.answers._slotDay + ' · ' + this.answers._slotTime) +
            '</div>'
          : '') +
        '<div class="ss-diagnostic-quiz__nav" style="justify-content:center"><button type="button" class="button-secondary" data-again>' +
        this.escapeHtml(this.labels.restartLabel || '') +
        '</button></div>';
      this.stage.appendChild(s);
      s.querySelector('[data-again]').addEventListener('click', () => {
        for (const k in this.answers) delete this.answers[k];
        this.goIntro();
      });
    }

    scrollToTop() {
      if (this.getBoundingClientRect().top < 0) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    escapeHtml(str) {
      if (str == null) return '';
      return String(str).replace(
        /[&<>"']/g,
        (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]
      );
    }

    escapeAttr(str) {
      return this.escapeHtml(str);
    }
  }

  if (!customElements.get('ss-diagnostic-quiz')) {
    customElements.define('ss-diagnostic-quiz', SsDiagnosticQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
